import { Component, OnInit,ViewChild  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CryptoJsService } from './../../services/crypto-js.service';

import { first } from 'rxjs/internal/operators/first';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import * as CryptoJS from 'crypto-js';
import { MenuService } from 'src/app/services/app.menu.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { JEService } from 'src/app/services/je-services.service';
import { SuperAdminService } from 'src/app/services/super-admin.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService } from 'primeng/api';
import * as XLSX from 'xlsx';
import { MessageService } from 'primeng/api';
import { GoogleMapComponent } from '../google-map/google-map.component';
// import { GMap } from 'primeng/gmap';

// declare var google: any;

@Component({
  selector: 'app-complete-user-list',
  templateUrl: './complete-user-list.component.html',
  styleUrls: ['./complete-user-list.component.scss']
})
export class CompleteUserListComponent implements OnInit {

  geoMappings: any[] = [];
  loading = false;
  


  // ✅ Store fetched villages per GeoCode
  geoDetailsMap: { [geoCode: string]: any[] } = {};
 

  showLoginPanel = false;
generatedLoginDetails: any = null;
geoDetails: any[] = [];



  geoDetailsDialogVisible = false;
  selectedGeoCode: string | null = null;
  selectedGeoName: string | null = null;

//map
// @ViewChild('gmap') gmap!: GMap;

// geoMapDialogVisible = false;
// mapReady = false;

// options: any;
// overlays: any[] = [];
// bounds!: google.maps.LatLngBounds;



  constructor(
    private messageService: MessageService,
    private fb: FormBuilder,  
    public router: Router,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService,
    private adminservice: SuperAdminService,
    private confirmserv: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.loadGeoMappings();

  }

  loadGeoMappings() {
    this.loading = true;

    //GetAllGeoMappings
    
    this.adminservice.GetAllGeoMappings().subscribe({
      next: (res: any) => {
        this.geoMappings = res?.$values || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load Geo Mappings'
        });
      }
    });
  }


/** 🟢 Called when user clicks the View Mapping button */
openGeoMappingPopup(geoCode: string, geoName: string) {
  this.selectedGeoCode = geoCode;
  this.selectedGeoName = geoName;
  this.geoDetailsDialogVisible = true;

  // If already cached, show immediately
  if (this.geoDetailsMap[geoCode]) {
    this.geoDetails = this.geoDetailsMap[geoCode];
    return;
  }

  // Otherwise, fetch from API
  this.loadGeoDetails(geoCode);
}

/** 🟣 Load geo details from API */
loadGeoDetails(geoCode: string) {
  this.adminservice.getGeoDetailsByGeoID(geoCode).subscribe({
    next: (res: any) => {
      const details = res?.$values || [];
      this.geoDetailsMap[geoCode] = details;
      this.geoDetails = details;
    },
    error: (err) => {
      console.error('Geo Details API Error:', err);
      this.geoDetails = [];
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `Failed to load Geo Details for ${geoCode}`,
      });
    },
  });
}



getGeoRowColor(geoType: string): string {
  switch (geoType?.toLowerCase()) {
    case 'district':
      return '#ffcccc'; // 🌸 Light Red (soft rose)
    case 'block':
      return '#cce5ff'; // 💧 Light Blue (soft sky)
    case 'village':
      return '#ccffcc'; // 🌿 Light Green (pastel mint)
    case 'other':
      return '#e6f7ff'; // 🩵 Extra soft blue tint
    default:
      return 'transparent';
  }
}

  refreshTable() {
    this.loadGeoMappings();
  }

   /** 🔹 Export to Excel */
   exportExcel() {
    if (!this.geoMappings.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'No data available to export.'
      });
      return;
    }

    const exportData = this.geoMappings.map((x, i) => ({
      'S.No': i + 1,
      'User Type': x.userType,
      'User ID': x.userID,
      'Officer Name': x.officer_Name,
      Mobile: x.mobile,
      Email: x.emailID,
      'Geo Name': x.geoName,
      // 'Geo Code': x.geoCode,
      'Geo Type': x.geoType,
      Action: x.action,
      'Assign Mapping Date': x.assignMappingDate
        ? new Date(x.assignMappingDate).toLocaleString()
        : '',
      'Unassign Mapping Date': x.unassignMappingDate
        ? new Date(x.unassignMappingDate).toLocaleString()
        : ''
      // Active: x.active === 1 ? 'Yes' : 'No'
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Geo Mappings');

    const colWidths = Object.keys(exportData[0]).map((key) => ({
      wch: Math.max(key.length + 2, 18)
    }));
    ws['!cols'] = colWidths;

    XLSX.writeFile(
      wb,
      `User_Geo_Mappings_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  }
  loadGeoMappingsWithDelay() {
    this.loading = true; // show loader
  
    // Delay before hitting API (e.g., 1.5 seconds)
    setTimeout(() => {
      this.loadGeoMappings();
    }, 1500);
  }
  
// map start here
// Called when dialog shows
// onMapDialogShow() {
//   this.mapReady = true;

//   this.options = {
//     center: { lat: 29.0588, lng: 76.0856 },
//     zoom: 7,
//     mapTypeId: google.maps.MapTypeId.ROADMAP,
//   };

//   this.overlays = [];
//   this.bounds = new google.maps.LatLngBounds();

  // Resize & recenter map after dialog render
//   setTimeout(() => {
//     const map = this.gmap?.map;
//     if (map) {
//       google.maps.event.trigger(map, 'resize');
//       map.setCenter({ lat: 29.0588, lng: 76.0856 });
//     }
//   }, 500);
// }

// openGeoMap(userID: string) {
//   this.geoMapDialogVisible = true;

//   const userMappings = this.geoMappings.filter(g => g.userID === userID);

//   if (!userMappings.length) {
//     this.messageService.add({
//       severity: 'warn',
//       summary: 'No Data',
//       detail: 'No geo mapping found for this user.'
//     });
//     return;
//   }

//   setTimeout(() => {
//     userMappings.forEach(mapping => {
//       this.showGeoNameLocation(mapping.geoName, mapping.geoType, mapping.userID);
//     });
//   }, 800);
// }

// ✅ Search directly using geoName, not static lat/lng
// showGeoNameLocation(geoName: string, geoType: string, userID: string) {
//   const map = this.gmap?.map;
//   if (!map || !geoName) return;

//   const service = new google.maps.places.PlacesService(map);

//   const request = {
//     query: `${geoName}, Haryana, India`,
//     fields: ['name', 'geometry']
//   };

//   service.findPlaceFromQuery(request, (results: any, status: any) => {
//     if (status === google.maps.places.PlacesServiceStatus.OK && results[0]) {
//       const loc = results[0].geometry.location;
//       const marker = new google.maps.Marker({
//         position: loc,
//         title: `${geoType}: ${geoName} (User: ${userID})`,
//         icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
//       });

//       this.overlays = [...this.overlays, marker];
//       this.bounds.extend(loc);
//       map.fitBounds(this.bounds);
//     } else {
//       this.messageService.add({
//         severity: 'warn',
//         summary: 'Location Not Found',
//         detail: `Could not locate "${geoName}". Showing Haryana instead.`,
//       });
//       map.setCenter({ lat: 29.0588, lng: 76.0856 });
//       map.setZoom(7);
//     }
//   });
// }

// handleOverlayClick(event: any) {
//   if (event.overlay?.getTitle) {
//     alert(event.overlay.getTitle());
//   }
// }

// handleMapClick(event: any) {
//   console.log('Map clicked at:', event.latLng);
// }

// handleDragEnd(event: any) {
//   console.log('Marker moved to:', event.overlay.getPosition());
// }



// map end
}

